import CustomDomainService from "@/pages/common/trend/service/CustomDomainService";
import CustomDomainActions from "./CustomDomainActions";
import CustomDomainMutations from "./CustomDomainMutations";

const state = CustomDomainService.EmptyCustomDomainStatefactory();

const { actions } = CustomDomainActions;

const { mutations } = CustomDomainMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	mutations,
};